import { Component, OnInit, Input } from '@angular/core';
import { Url } from 'url';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.sass']
})
export class NotificationComponent implements OnInit {

  constructor() { }

  @Input() notificationType: string;
  @Input() notificationTitle: string;
  @Input() notificationText: string;
  @Input() notificationLinkUrl: Url;
  @Input() notificationLinkText: string;

  isDismissed: boolean = false;

  dismissNotification() {
    this.isDismissed = true;
  }

  ngOnInit() {
  }

}
